import { Link, Outlet, useRouterState } from '@tanstack/react-router';
import { PageHeader, cn, segmentedItemClass, segmentedListClass } from '@buildbee/ui';
import { withFeatures, type Feature } from '../../../lib/features';

type FinTab = { to: string; label: string; exact?: boolean; feature?: Feature };

/** Section tabs. Accounting sync, sub pay apps and lien waivers are hidden for now (lib/features.ts). */
export const FINANCIALS_TABS: FinTab[] = [
  { to: '/financials', label: 'Overview', exact: true },
  { to: '/financials/invoices', label: 'Invoices' },
  { to: '/financials/change-orders', label: 'Change orders' },
  { to: '/financials/commitments', label: 'Subcontracts & POs' },
  { to: '/financials/pay-apps', label: 'Sub pay apps', feature: 'fin.pay-apps' },
  { to: '/financials/lien-waivers', label: 'Lien waivers', feature: 'fin.lien-waivers' },
  { to: '/financials/reports', label: 'Reports' },
  { to: '/financials/accounting', label: 'Accounting', feature: 'fin.accounting' },
  { to: '/financials/cost-codes', label: 'Cost codes' },
];

export function FinancialsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  if (/\/financials\/invoices\/[^/]+\/print\/?$/.test(pathname)) return <Outlet />;
  // One project's money has its own header and tabs (Budget, Billing, ...); the company-wide tabs
  // on top of them read as a second, competing menu.
  if (/\/financials\/projects\/[^/]+\/?$/.test(pathname)) return <Outlet />;
  return (
    <div>
      <PageHeader title="Financials" description="Budgets, subcontracts, change orders, invoices and payments." />
      <nav aria-label="Financials" className={cn(segmentedListClass, 'mb-6')}>
        {withFeatures(FINANCIALS_TABS).map((t) => {
          const active = t.exact ? pathname === t.to || pathname === `${t.to}/` : pathname.startsWith(t.to);
          return (
            <Link
              key={t.to}
              to={t.to}
              className={segmentedItemClass(active)}
            >
              {t.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
